import { Userpilot } from "userpilot";
import { SiteLicense } from "../../../types/api.types";
import type {
  CurrentUser,
  SiteCategoriesSummaryResponse
} from "../../../utils/backend-types";

declare const USERPILOT_ID: string;

/**
 * Whether UserPilot is actually configured to load. `USERPILOT_ID` is injected
 * at build time (vite.shared.config.ts) and defaults to "" in dev, where
 * `Userpilot.initialize("")` is a no-op so the launcher never appears. It's
 * `undefined` in environments without the define (e.g. Storybook), hence the
 * typeof guard.
 */
export function isUserpilotConfigured(): boolean {
  return typeof USERPILOT_ID !== "undefined" && USERPILOT_ID !== "";
}

export function loadUserpilot(
  currentUser: CurrentUser,
  siteCategories: SiteCategoriesSummaryResponse
) {
  Userpilot.initialize(USERPILOT_ID);
  Userpilot.identify(currentUser.id.toString(), {
    user_type: currentUser.is_staff ? "internal" : "external",
    ee_plus: siteCategories.is_eigenerzeugung_plus ? "yes" : "no",
    premium:
      siteCategories.license.find(
        (licenseEntry) => licenseEntry.value === SiteLicense.premium
      ) !== undefined
        ? "yes"
        : "no",
    partial_feedin_site: siteCategories.is_partial_feedin_site ? "yes" : "no"
  });
}
